import { BasePageModel } from 'models/BasePageModel';
import { MediumAd } from 'models/MediumAd';
import { PageState } from 'models/PageState';

export const getMenuAds = (currentPage: BasePageModel) => currentPage.menuAds;

export const getMenuAdsById = (
  id: string,
  adsMap?: { [key: string]: MediumAd[] }
): MediumAd[] | undefined => {
  return adsMap && adsMap[id.toLowerCase()];
};

const BRAND_IDS = ['/merker/', '/varumarken/'];

export const selectSections = (state: PageState) => state.header.mainMenu.items;
export const selectOurBrands = (state: PageState) =>
  state.header.secondaryMenu.find(menuItem => BRAND_IDS.includes(menuItem.id)) || { title: '', url: '', ticket: '' };

export const isAllCategoriesMenuItem = (id: string) => id === 'X666';

export const getMainMenuOpen = (state: PageState) => state.header.mainMenu.isOpen;
export const getMainMenuItems = (state: PageState) => state.header.mainMenu.items;

export const getSecondaryMenu = (state: PageState) => state.header.secondaryMenu;
